import { render, staticRenderFns } from "./privacyq.vue?vue&type=template&id=c9887142&"
import script from "./privacyq.vue?vue&type=script&lang=js&"
export * from "./privacyq.vue?vue&type=script&lang=js&"
import style0 from "./privacyq.vue?vue&type=style&index=0&id=c9887142&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports